import styled, { useTheme } from 'styled-components'
import FlatIcon from '@/components/common/icons/FlatIcon'
import { Typo, TypoVariant } from '@/components/common/typography'
import { IngredientText } from '@/components/domains/product-detail/product-detail.type'
import { IconNameEnum } from '@/constants/icon-name.enum'

const INGREDIENT_BOTTOM_SHEET = {
  ingredientTitle: '비슷한 성분 상품 추천 기준',
  ingredientMainGuide:
    'AAFCO(미 사료협회)의 반려동물 사료 영양소 기준치를 바탕으로 수의 영양학을 연구한 수의사의 자문을 받아 제공됩니다.',
  description: {
    LOW_PROTEIN:
      '* 영양소 기준치는 만 1세 이상의 건강한 성견・성묘를 대상으로 하고 있습니다.\n* 특정 질환을 앓고 있거나 유전적 질병에 대한 품종 소인이 있는 경우 혹은 인 제한이 필요하다고 생각되는 경우 꼭 수의사 선생님과 충분히 논의 후 급여해 주세요.',
    HIGH_PROTEIN:
      '* 영양소 기준치는 만 1세 이상의 건강한 성견・성묘를 대상으로 하고 있습니다.\n* 특정 질환을 앓고 있거나 유전적 질병에 대한 품종 소인이 있는 경우 지나친 고단백 식이는 간에 부담을 줄 수 있으니 꼭 수의사 선생님과 충분히 논의 후 급여해 주세요.',
    LOW_FAT:
      '* 영양소 기준치는 만 1세 이상의 건강한 성견・성묘를 대상으로 하고 있습니다.\n* 특정 질환을 앓고 있거나 유전적 질병에 대한 품종 소인이 있는 경우 혹은 단백질 제한이 필요하다고 생각되는 경우 꼭 수의사 선생님과 충분히 논의 후 급여해 주세요.',
    LOW_PHOSPHORUS:
      '* 영양소 기준치는 만 1세 이상의 건강한 성견・성묘를 대상으로 하고 있습니다.\n* 특정 질환을 앓고 있거나 유전적 질병에 대한 품종 소인이 있는 경우 혹은 피모, 체중에 급격한 변화가 있는 경우 꼭 수의사 선생님과 충분히 논의 후 급여해 주세요.',
  },
  ingredientReportWrongGuide: '잘못된 정보가 있을 시 1:1 문의로 제보해주세요',
}

export const ProductDetailIngredientsInfo = ({ selectIngredientType }: { selectIngredientType: IngredientText }) => {
  const { color } = useTheme()
  return (
    <ProductDetailIngredientsInfoWrapper className="product-detail-ingredients-info">
      <div className="product-detail-ingredients-info__title">
        <Typo variant={TypoVariant.Heading6Bold} color={color.gray900}>
          {INGREDIENT_BOTTOM_SHEET.ingredientTitle}
        </Typo>
      </div>
      <div className="product-detail-ingredients-info__paragraph">
        <Typo variant={TypoVariant.Body3Regular} color={color.gray900}>
          {INGREDIENT_BOTTOM_SHEET.ingredientMainGuide}
        </Typo>
      </div>
      <div className="product-detail-ingredients-info__content">
        <Typo
          variant={TypoVariant.Body5Regular}
          color={color.gray900}
          style={{
            whiteSpace: 'pre-line',
          }}
        >
          {INGREDIENT_BOTTOM_SHEET.description[selectIngredientType]}
        </Typo>
      </div>
      <footer className="product-detail-ingredients-info__footer">
        <FlatIcon type={IconNameEnum.IcInfo} color={color.gray200} size="1.6rem" />
        <Typo variant={TypoVariant.Body3Medium} color={color.gray500}>
          {INGREDIENT_BOTTOM_SHEET.ingredientReportWrongGuide}
        </Typo>
      </footer>
    </ProductDetailIngredientsInfoWrapper>
  )
}

const ProductDetailIngredientsInfoWrapper = styled.div`
  padding: 0 1.6rem calc(2.4rem + env(safe-area-inset-bottom));
  .product-detail-ingredients-info {
    &__title {
    }
    &__paragraph {
      margin-top: 1.6rem;
    }
    &__content {
      margin-top: 1.6rem;
    }
    &__footer {
      margin-top: 3.2rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 0.4rem;
    }
  }
`
